<div class="welcome-container" #container>
  <div class="animation-element shown">
    <h1>Welcome to</h1>
    <img src="../../../assets/img/afas-logo-white.jpg" alt="Automated Family Alert System" />
  </div>

  <div class="animation-element hidden">
    <h1>Let's take a few minutes and get you signed up.</h1>
  </div>

  <div class="animation-element hidden">
    <h1>We suggest, for this operation, to expand the sidebar to accommodate a more complex form</h1>
  </div>
</div>
